import './ContentTitle.css';
import { useAppUi } from '../../app-ui/AppUiScope';
import baseline, { appTextStyle } from '../../app-ui/baseline';
import React from 'react';

export default function ContentTitle({ title, explicit, inlineExplicit = false, style }) {
  const appUi = useAppUi();
  return (
    <strong
      style={{ ...(appUi ? appTextStyle(baseline.contentText.title) : {}), ...style }}
      className={`pp-content-title${inlineExplicit ? ' pp-content-title-inline' : ''}`}
    >
      <span className="pp-content-title-text">{title}</span>
      {explicit && (
        <small className="pp-explicit" aria-label="Explicit">
          E
        </small>
      )}
    </strong>
  );
}
